import { render, staticRenderFns } from "./FormularioNuevoCalendario.vue?vue&type=template&id=1ca56b29&scoped=true"
import script from "./FormularioNuevoCalendario.vue?vue&type=script&lang=js"
export * from "./FormularioNuevoCalendario.vue?vue&type=script&lang=js"
import style0 from "./FormularioNuevoCalendario.vue?vue&type=style&index=0&id=1ca56b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca56b29",
  null
  
)

export default component.exports